export const GET_LEAD_AD_TYPES = 'GET_LEAD_AD_TYPES';
export const GET_LEAD_AD_TYPES_SUCCESS = 'GET_LEAD_AD_TYPES_SUCCESS';
export const UPDATE_LEAD_AD_TYPES_SUCCESS = 'UPDATE_LEAD_AD_TYPES_SUCCESS';
export const ADD_LEAD_AD_TYPES_SUCCESS = 'ADD_LEAD_AD_TYPES_SUCCESS';
export const DELETE_LEAD_AD_TYPES_SUCCESS = 'DELETE_LEAD_AD_TYPES_SUCCESS';
export const SET_FETCHING_LEAD_AD = 'SET_FETCHING_LEAD_AD';